var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layer-portal',_vm._g(_vm._b({ref:"portal",attrs:{"wrapper-class":_vm.wrapperClass,"content-class":_vm.contentClass,"content-style":_vm.contentStyle,"z-index-increment":_vm.zIndexIncrement}},'layer-portal',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }